/**
 * Replacement for vue-mapbox's $helpers.asControl mixin.
 * Injects the map instance and provides $_addControl / $_removeControl methods.
 */
export default {
  inject: ["map"],
  methods: {
    $_addControl() {
      if (this.map && this.control) {
        this.map.addControl(this.control, this.position || "top-right");
      }
    },
    $_removeControl() {
      if (this.map && this.control) {
        this.map.removeControl(this.control);
      }
    },
  },
  beforeDestroy() {
    this.$_removeControl();
  },
};
